import { render, staticRenderFns } from "./CoachingMessage.vue?vue&type=template&id=3fbfb822&scoped=true"
import script from "./CoachingMessage.vue?vue&type=script&lang=js"
export * from "./CoachingMessage.vue?vue&type=script&lang=js"
import style0 from "./CoachingMessage.vue?vue&type=style&index=0&id=3fbfb822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfb822",
  null
  
)

export default component.exports